import { render, staticRenderFns } from "./Courses.vue?vue&type=template&id=37e7fd19"
var script = {}
import style0 from "./Courses.vue?vue&type=style&index=0&id=37e7fd19&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports